import React from 'react'
import {Flex, Text} from '../../../../vanilla'
import {ExclamationCircleIcon} from '../../../icons'
import {useRapidDeliveryStore} from '../../../../store/hooks/useStore'
import {observer} from 'mobx-react'

export const ReservationExpiredSlot = observer(() => {
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()

  return (
    <Flex gap="2px" align="center" marginTop="4px" >
      <ExclamationCircleIcon color="accent0" boxSize="12px" marginRight="4px" />
      <Text variant="text1" color="accent0" lineHeight="short" data-test-selector="delivery-reservation-expired">
        {isRapidDeliveryBooked ? 'Your delivery booking has expired!' : 'Your delivery slot has expired!'}
      </Text>
    </Flex>
  )
})
